import type { ShopMessageKey } from '../../../i18n'
import type { CheckoutValidationError } from '../../types'
import type { CheckoutAddressForm } from '../CheckoutFlow.types'
import type { TranslateFn } from './types'

const POSTAL_CODE_REGEX = /^[A-Za-z0-9][A-Za-z0-9\-\s]{2,11}$/
const COUNTRY_REGEX = /^[A-Za-z]{2}$/
const PHONE_REGEX = /^[0-9+()\-\s]{6,20}$/

export const validateAddressForm = ({
  form,
  t,
}: {
  form: CheckoutAddressForm
  t: TranslateFn
}): CheckoutValidationError[] => {
  const requiredFields: Array<{ key: keyof CheckoutAddressForm; labelKey: ShopMessageKey }> = [
    { key: 'firstName', labelKey: 'checkout.field.firstName' },
    { key: 'lastName', labelKey: 'checkout.field.lastName' },
    { key: 'line1', labelKey: 'checkout.field.line1' },
    { key: 'city', labelKey: 'checkout.field.city' },
    { key: 'postalCode', labelKey: 'checkout.field.postalCode' },
    { key: 'country', labelKey: 'checkout.field.country' },
  ]

  const errors: CheckoutValidationError[] = requiredFields
    .filter(({ key }) => form[key].trim().length === 0)
    .map(({ key, labelKey }) => ({
      field: String(key),
      message: t('checkout.validation.required', { field: t(labelKey) }),
    }))

  const postalCode = form.postalCode.trim()
  if (postalCode && !POSTAL_CODE_REGEX.test(postalCode)) {
    errors.push({ field: 'postalCode', message: t('checkout.validation.postalCodeInvalid') })
  }

  const country = form.country.trim()
  if (country && !COUNTRY_REGEX.test(country)) {
    errors.push({ field: 'country', message: t('checkout.validation.countryInvalid') })
  }

  const phone = form.phone.trim()
  if (phone && !PHONE_REGEX.test(phone)) {
    errors.push({ field: 'phone', message: t('checkout.validation.phoneInvalid') })
  }

  return errors
}
